<script>
    import { hexToRgbA } from '../utils/helper';
    import moment from 'moment';
    import { Bar } from 'vue-chartjs';

    export default {
        name: 'Barchart',
        props: {
            statistics: {},
            filterVehicle: {},
            filterBrand: {},
            filterYear: {},
        },
        data() {
            return {
                options: {
                    aspectRatio: 1,
                    tooltips: {
                        backgroundColor: '#707070',
                        bodyFontFamily: 'Roboto',
                        bodyFontSize: 11,
                        bodySpacing: 10,
                        borderColor: '#707070',
                        caretPadding: 10,
                        caretSize: 10,
                        cornerRadius: 4,
                        displayColors: false,
                        mode: 'index',
                        position: 'nearest',
                        titleFontFamily: 'Roboto',
                        titleFontSize: 13,
                        titleMarginBottom: 20,
                        xPadding: 20,
                        yPadding: 15,
                    },
                    legend: {
                        align: 'start',
                        labels: {
                            fontColor: 'white',
                            fontFamily: 'Roboto',
                            fontSize: 8,
                            padding: 10,
                            boxWidth: 20,
                        },
                        position: 'bottom',
                        onClick: (e) => e.stopPropagation(),
                    },
                    maintainAspectRatio: false,
                    scales: {
                        xAxes: [{
                            ticks: {
                                fontSize: '8',
                                fontColor: 'white',
                                fontFamily: 'Roboto',
                                beginAtZero: true,
                                userCallback: this.labelFormatter,
                            },
                            stacked: true,
                            gridLines: {
                                color: "transparent"
                            },
                        }],
                        yAxes: [{
                            ticks: {
                                fontSize: '8',
                                fontColor: 'white',
                                fontFamily: 'Roboto',
                                beginAtZero: true,
                                userCallback: this.labelFormatter,
                            },
                            stacked: true,
                            gridLines: {
                                color: "transparent"
                            },
                        }]
                    }
                },
            }
        },
        mixins: [
            Bar,
        ],
        methods: {
            labelFormatter(label, index, labels) {
                if (Math.floor(label) === label) {
                    return label;
                }
            },
        },
        computed: {
            data() {
                const datasets = [];

                this.statistics.forEach((brand) => {
                    if (this.filterBrand && brand.name.toLowerCase() !== this.filterBrand) return;
                    let data = [];
                    if (!brand) console.error('brand is missing');
                    if (!brand.years) console.error('years of brand are missing');
                    brand.years.forEach((year, index) => {
                        if (this.filterYear.length > 0 && !this.filterYear.includes(index)) return;
                        let colors = [];
                        if (!year.months) console.error('months in year are missing');
                        const colorToSet = hexToRgbA(brand.color, (index + 1) / brand.years.length);
                        data = year.months.map((m) => {
                            colors.push(colorToSet);
                            if (this.filterVehicle) {
                                return m[this.filterVehicle];
                            } else {
                                return m.cuv + m.ww;
                            }
                        });
                        datasets.push({
                            stack: year.name,
                            label: `${brand.name.toUpperCase()} ${year.name}`,
                            data: data,
                            backgroundColor: colors,
                            borderColor: colors,
                        });
                    });

                });

                return {
                    labels: Array.apply(0, Array(12)).map((_, i) => {
                        return moment().locale(this.$i18n.locale).month(i).format('MMM')
                    }),
                    datasets,
                };
            }
        },
        watch: {
            filterVehicle() {
                this._data._chart.destroy();
                this.renderChart(this.data, this.options)
            },
            filterBrand() {
                this._data._chart.destroy();
                this.renderChart(this.data, this.options)
            },
            filterYear() {
                this._data._chart.destroy();
                this.renderChart(this.data, this.options)
            },
        },
        mounted() {
            this.$nextTick(() => {
                this.renderChart(this.data, this.options)
            });
        },
    }
</script>
